import React from "react";
import "../css/BehindLens.css";
import assets from '../assets/images'

const BehindLens = () => {
  return (
    <div className="behind-lens-container">
      {/* Background Image */}
      <div 
  className="background-image" 
  style={{ backgroundImage: `url(${assets.priyantha_hero2})` }}
></div>


      {/* Title with Decorative Line */}
      <div className="title-section">
      <h2>The man behind the Lens</h2>
          <div className="title-vis-line">
        <span className="vis-dot"></span>
        <span className="vis-line"></span>
        <span className="vis-dot"></span>
      </div>
      </div>

      {/* Content Section */}
      <div className="content-section">
        {/* Framed Image */}
        <div className="framed-image">
          <div className="frame-border">
            <img src={assets.priyantha} alt="Photographer Portrait" />
          </div>
        </div>

        {/* Text Content */}
        <div className="text-content">
          <p>
          Priyantha Bandara is the visionary behind Priyantha Bandara Photography, a brand synonymous with creativity, passion, and excellence in wedding photography. With years of experience in the industry, he has mastered the art of capturing love stories through his lens, turning fleeting moments into timeless treasures.<br/><br/>

His keen eye for detail, innovative approach, and commitment to perfection have earned him a reputation as one of the most sought after wedding photographers. Whether it’s a grand celebration or an intimate gathering, Priyantha ensures that every frame reflects the true emotions and essence of the couple’s journey.<br/><br/>

Driven by a deep love for storytelling, he believes that photography is more than just pictures it’s about preserving emotions, laughter, and unforgettable memories for generations to come. Under his leadership, Priyantha Bandara Photography continues to set new standards in the industry, offering clients a seamless blend of artistry, elegance, and professionalism.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BehindLens;
